import { authWSClient } from 'WSClient/index';

export default {
  setupNotification({ dispatch }) {
    authWSClient.subscribe(
      'system',
      null,
      message => dispatch('handleNotification', message),
    );
  },
  handleNotification({ dispatch }, message) {
    if (message.message.action === 'logout') dispatch('login/logout', true, { root: true });
  },
};
